export const access_token = process.env.REACT_APP_ACCESS_TOKEN;
export const refresh_token = process.env.REACT_APP_REFRESH_TOKEN;
export const api_urls_http = process.env.REACT_APP_APP_URLS_HTTP;
export const api_urls_https = process.env.REACT_APP_APP_URLS_HTTPS;
export const google_api_keys = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
export const website_name = 'AstroFriends';
export const razorpay_test_key = 'rzp_test_7FcETDDAqUcnFu';
export const razorpay_live_key = 'rzp_live_oTDlfILa14R5io';